import React from 'react'
import _ from 'lodash/fp'

import { Link } from 'react-router-dom'

import { withStyles } from '@material-ui/core/styles'

import Card from '@material-ui/core/Card'
import CardActionArea from '@material-ui/core/CardActionArea'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Hidden from '@material-ui/core/Hidden'

import colors from '@fe/ui/colors'

const styles = theme => ({
  card: {
    maxWidth: '40vh',
    margin: 12,
    flex: 1,
    boxShadow: 'none',
    color: colors.lightGreen
  },
  cardMedia: {
    paddingTop: '75%',
    backgroundPosition: 'top'
  },
  cardContent: {
    paddingTop: 6,
    padding: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.7em'
    }
  },
  title: {
    color: theme.palette.text.primary,
    fontWeight: 'normal',
    fontSize: '1.8em',
    margin: 0
  },
  vendor: {
    color: theme.palette.text.primary,
    fontWeight: 'normal',
    fontSize: '1.3em',
    margin: 0,
    textTransform: 'uppercase'
  },
  price: {
    fontSize: '1.7em',
    color: colors.lightGreen
  },
  compareAtPrice: {
    fontSize: '1.7em',
    paddingRight: 8,
    color: theme.palette.text.primary,
    textDecoration: 'line-through'
  }
})

const Offer = ({ id, title, clubId, image, price, compareAtPrice, vendor, handle, classes }) => (
  <Card className={classes.card} component={Link} to={`/offers/offer/${handle}`}>
    <CardActionArea style={{ width: '100%' }}>
      <CardMedia
        className={classes.cardMedia}
        image={image}
        title={title}
      />
      <CardContent className={classes.cardContent}>
        <h2 className={classes.title}>
          {title}
        </h2>
        <h2 className={classes.vendor}>
          {vendor}
        </h2>
        <div>
          {isNaN(compareAtPrice) ||
            <Hidden smDown>
              <span className={classes.compareAtPrice}>{compareAtPrice} kr.</span>
            </Hidden>}
          <span className={classes.price}>
            {price} kr.
          </span>
        </div>
      </CardContent>
    </CardActionArea>
  </Card>
)

export default _.compose(
  withStyles(styles)
)(Offer)
